import { QUIZ_VERSION } from './config'

/**
 * Lightweight per-screen analytics ping.
 *
 * Fires a fire-and-forget POST to /.netlify/functions/ping on each screen
 * mount. Used to build the funnel drop-off chart in the dashboard.
 *
 * A sessionId is generated once per browser session and reused across all
 * screen pings so the dashboard can count unique sessions per step, not raw
 * hits (which would double-count back-navigation).
 */

const SESSION_ID_KEY = 'np-fitquiz:session-id'
const PING_ENDPOINT  = '/.netlify/functions/ping'

export type ScreenName = 'intro' | 'activity' | 'pain' | 'shape' | 'height' | 'result'

function getSessionId(): string {
  try {
    const existing = sessionStorage.getItem(SESSION_ID_KEY)
    if (existing) return existing
    const id = crypto.randomUUID()
    sessionStorage.setItem(SESSION_ID_KEY, id)
    return id
  } catch {
    // sessionStorage blocked (e.g. private-browsing + strict settings).
    // Generate a one-off ID that won't survive navigation — pings still fire,
    // they'll just look like separate sessions.
    return crypto.randomUUID()
  }
}

export function pingScreen(screen: ScreenName): void {
  try {
    const sessionId = getSessionId()
    fetch(PING_ENDPOINT, {
      method:    'POST',
      headers:   { 'content-type': 'application/json' },
      body:      JSON.stringify({ screen, sessionId, quizVersion: QUIZ_VERSION }),
      keepalive: true, // fires even if the user navigates away immediately
    }).catch(() => { /* fire and forget — analytics must never break the quiz */ })
  } catch {
    // noop
  }
}
